import instance from '@src/api/common';

export function getMetricList(preferredVersion?: string) {
  return instance.get(
    `/v1/metrics${preferredVersion ? `?preferred_version=${preferredVersion}` : ''}`,
  );
}
export function postCoverageReport(queryBody: any) {
  return instance.post(`/v1/event_coverage`, queryBody);
}
